import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input, Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import { Link } from "react-router-dom";


const GenerateInvoiceModal = ({
  show,
  onCloseClick,
  onConfirm,
  orderDetail,
  orderId
}: any) => {
  const [selectedTime, setSelectedTime] = useState<number | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const handleTimeSelect = (time: any) => {
    setSelectedTime(time);
  };



  

  return (
    <>
      <Modal isOpen={show} centered={true} className="GenerateInvoiceModal">
        <ModalBody className="modal_Body">
          <img
            data-testing-id="closeIcon"
            onClick={() => onCloseClick(false)}
            className='closeIconModal'
            src={CLoseImg}
            alt=""
          />

          <div className="heading">
            <h1>Please accept this order to generate the invoice.</h1>
            <button onClick={() => window.open(`/ecommerce-orders/${orderId}`, "_blank")}>
              View Order Details
            </button>

          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

GenerateInvoiceModal.propTypes = {
  onCloseClick: PropTypes.func,
  onConfirm: PropTypes.func,
  show: PropTypes.bool,
  orderDetail: PropTypes.any,
  orderId: PropTypes.any,
};

export default GenerateInvoiceModal;
